import * as React from "react";
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

import { getDiffEditorSettings } from "../lang/settings";
import { MonacoDiffEditorProps } from "../model/model";
import { useEditor } from "../hooks/useEditor";
import { DiffEditor } from "@monaco-editor/react";
import { singleLineDiffMonacoEditorRestriction } from "../lang/restrictions";
import { ThemeType } from "shared/styles/theme";
import useUserTheme from "shared/styles/hooks/useUserTheme";

const DiffMonacoEditor: React.FC<MonacoDiffEditorProps> = ({ original, modified, mode, options }) => {
    const [theme] = useUserTheme();
    const editorRef = React.useRef<monaco.editor.IStandaloneDiffEditor>();
    const monacoRef = React.useRef<typeof monaco>();
    const language = useEditor({ mode, editorRef, monacoRef, isDiff: true });

    const [diffEditorHeight, setDiffEditorHeight] = React.useState<number>(300);
    const [diffEditorOptions, setDiffEditorOptions] = React.useState<monaco.editor.IDiffEditorConstructionOptions | undefined>(options);

    const handleOnMount = (editor: monaco.editor.IStandaloneDiffEditor, monacoInstance: typeof monaco) => {
        getDiffEditorSettings(editor);
        const originalLineCount = editor.getModel()?.original.getLineCount();
        const modifiedLineCount = editor.getModel()?.modified.getLineCount();
        if (originalLineCount !== undefined && modifiedLineCount !== undefined && originalLineCount === 1 && modifiedLineCount === 1) {
            setDiffEditorHeight(20);
            setDiffEditorOptions({ ...diffEditorOptions, ...singleLineDiffMonacoEditorRestriction });
        }
        editorRef.current = editor;
        monacoRef.current = monacoInstance;
    }

    return (
        <div className="diff-monaco-editor">
            <DiffEditor
                height={`${diffEditorHeight}px`}
                original={original}
                modified={modified}
                theme={theme === ThemeType.light ? "frends-light" : "frends-dark"}
                options={diffEditorOptions}
                language={language}
                onMount={handleOnMount}
            />
        </div>
    )
}

export default DiffMonacoEditor;